<script lang="ts" context="module">
	import { env } from "$lib/env.client";
</script>

<script lang="ts">
	export let isSmoreAdmin: boolean = false;
	export let isDeleted: boolean = false;
	export let isAuthorGhosted: boolean = false;
</script>

<!-- "Author is Ghosted" banner -->
{#if isSmoreAdmin}
	{#if isAuthorGhosted}
		<div class="container-1000 relative mb-10 rounded bg-[#fff7e2] p-4 text-center text-md font-medium" style="border: 1px solid #dddddd;">
			The author of this newsletter is ghosted. Access to this newsletter will result in 404.
		</div>
	{/if}

	{#if isDeleted}
		<div
			class="container-1000 tw-p-4 tw-relative tw-rounded tw-mb-10 tw-font-medium tw-text-md tw-text-center"
			style="background-color: #fff7e2; border: 1px solid #dddddd;">
			This newsletter is <b>deleted</b> and is invisible to everyone.
			<br />
			{#if env.isDevelopment}
				You can see this page because you are a Smore developer.
			{:else}
				You can see this page because you are a Smore admin.
			{/if}
		</div>
	{/if}
{/if}
